import { render, staticRenderFns } from "./job-detail.vue?vue&type=template&id=325a92a8&scoped=true"
import script from "./job-detail.vue?vue&type=script&lang=js"
export * from "./job-detail.vue?vue&type=script&lang=js"
import style0 from "./job-detail.vue?vue&type=style&index=0&id=325a92a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325a92a8",
  null
  
)

export default component.exports